import React from 'react';
import './index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { Link } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoChevronDown } from 'react-icons/io5';
import { format } from 'date-fns';

const TransactionDataTable = React.forwardRef(({ columns, data }, ref) => {
  return (
    <div className='transaction-datatable d-flex flex-column-reverse border rounded'>
      <table ref={ref} className='table table-hover mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 || index === 1 || index === 2 ? 'text-start bg-table-head' : 'text-end bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  const totalDebitTaxAmount = tb_items.debitAmount ? (tb_items.debitAmount - parseFloat(tb_items.debitAmount * 100) / parseFloat(tb_items.taxRate + 100)) : 0;
                  const totalDebitTaxableAmount = tb_items.debitAmount ? (parseFloat(tb_items.debitAmount) - parseFloat(totalDebitTaxAmount)) : 0;

                  const totalCreditTaxAmount = tb_items.creditAmount ? (tb_items.creditAmount - parseFloat(tb_items.creditAmount * 100) / parseFloat(tb_items.taxRate + 100)) : 0;
                  const totalCreditTaxableAmount = tb_items.creditAmount ? (parseFloat(tb_items.creditAmount) - parseFloat(totalCreditTaxAmount)) : 0;

                  const totalBalanceTaxAmount = tb_items.balanceAmount && (tb_items.balanceAmount - parseFloat(tb_items.balanceAmount * 100) / parseFloat(tb_items.taxRate + 100));
                  const totalBalanceTaxableAmount = tb_items.balanceAmount && (parseFloat(tb_items.balanceAmount) - parseFloat(totalBalanceTaxAmount));

                  const formattedNarration = tb_items.narration && typeof tb_items.narration === 'object' && tb_items.narration.join(", ").replace(/, ([^,]*)$/, " & $1");
                  return (
                    <tr key={index} className={index === 0 ? '' : 'border-top'}>
                      <td className='align-middle'>
                        {format(new Date(tb_items.transactionDate.seconds * 1000), "dd-MM-yyyy")}
                      </td>
                      <td className={tb_items.accountCode === 'Interest' ? 'align-middle text-danger' : 'align-middle'}>
                        <div className='hover-text cursor-pointer'>
                          <div className='text-ellipsis'>
                            <span className='pe-1'>{formattedNarration ? formattedNarration : tb_items.narration}</span>
                          </div>
                          <div className='text-line-1 text-normal text-muted pe-4'>
                            <small>{tb_items.description}</small>
                          </div>
                        </div>
                      </td>
                      <td className={tb_items.accountCode === 'Interest' ? 'align-middle text-danger' : 'align-middle'}>
                        {tb_items.paymentDetails ? tb_items.paymentDetails.paymentMode : '-'}
                      </td>
                      <td className="align-middle text-end">
                        <OverlayTrigger overlay={
                          <Tooltip style={{ minWidth: 240 }}>
                            <div className='row'>
                              <div className='col-6'>
                                <small>Amount</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalDebitTaxableAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                              <div className='col-6'>
                                <small>Tax ({tb_items.taxRate}%)</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalDebitTaxAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </Tooltip>
                        }>
                          <Link>
                            {tb_items.debitAmount ? parseFloat(parseFloat(tb_items.debitAmount).toFixed(2)).toLocaleString("en-IN") : '-'}
                          </Link>
                        </OverlayTrigger>
                      </td>
                      <td className="align-middle text-end">
                        <OverlayTrigger overlay={
                          <Tooltip style={{ minWidth: 240 }}>
                            <div className='row'>
                              <div className='col-6'>
                                <small>Amount</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalCreditTaxableAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                              <div className='col-6'>
                                <small>Tax ({tb_items.taxRate}%)</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalCreditTaxAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </Tooltip>
                        }>
                          <Link>
                            {tb_items.creditAmount ? parseFloat(parseFloat(tb_items.creditAmount).toFixed(2)).toLocaleString("en-IN") : '-'}
                          </Link>
                        </OverlayTrigger>
                      </td>
                      <td className="align-middle text-end">
                        <OverlayTrigger overlay={
                          <Tooltip style={{ minWidth: 240 }}>
                            <div className='row'>
                              <div className='col-6'>
                                <small>Amount</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalBalanceTaxableAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                              <div className='col-6'>
                                <small>Tax ({tb_items.taxRate}%)</small>
                                <div>
                                  <small>
                                    {parseFloat(parseFloat(totalBalanceTaxAmount).toFixed(2)).toLocaleString("en-IN")}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </Tooltip>
                        }>
                          <Link>
                            {parseFloat(parseFloat(tb_items.balanceAmount).toFixed(2)).toLocaleString("en-IN")}
                          </Link>
                        </OverlayTrigger>
                      </td>
                      {/* <td className="align-middle">
                        <div className='d-flex align-items-center justify-content-end'>
                          <Button variant="light" className='p-0 m-0 border-0'>
                            <div className='px-3 py-2 rounded'>
                              <IoChevronDown size={16} />
                            </div>
                          </Button>
                        </div>
                      </td> */}
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
});

export default TransactionDataTable;